import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type OtaReleaseRowFragment = { __typename?: 'OtaReleaseDocument', id: string, deviceModel: string, firmwareName: string, version: string, sha: string, profile: Types.DeviceProfile, channel: Types.OtaReleaseChannel, notes: string, status: Types.OtaReleaseStatus, createdAt: Types.TDateISO, publishedAt?: Types.TDateISO | null, haltedAt?: Types.TDateISO | null, haltReason: string };

export type OtaRolloutRowFragment = { __typename?: 'OtaRolloutDocument', id: string, lineId: string, releaseId: string, deviceModel: string, firmwareName: string, version: string, eligibleCountAtStart: number, status: Types.OtaRolloutStatus, currentRing: number, skippedRings: Array<number>, startedAt: Types.TDateISO, startedBy: string, endedAt?: Types.TDateISO | null, haltReason: string, rings: Array<{ __typename?: 'OtaRingPlanDocument', kind: Types.OtaRingKind, deviceIds: Array<string>, cutoffBps: number, maxDevices?: number | null, minApplied: number, successBps: number, haltMinFailures: number, haltBps: number }>, openedRings: Array<{ __typename?: 'OtaOpenedRingDocument', ringIndex: number, deviceCount: number, openedAt: Types.TDateISO }> };

export type OtaReleaseStateFragment = { __typename?: 'OtaReleaseStateData', releaseId: string, status: Types.OtaReleaseStatus };

export type OtaRolloutStateFragment = { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number };

export type OtaRolloutOperationFragment = { __typename?: 'OtaRolloutOperationData', applied: boolean, reason: Types.OtaNoOpReason, rollout?: { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number } | null };

export type GetOtaReleasesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OtaReleaseDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OtaReleaseDocumentSortInput> | Types.OtaReleaseDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOtaReleasesQuery = { __typename?: 'Query', otaReleases?: { __typename?: 'OtaReleasesConnection', totalCount: number, nodes?: Array<{ __typename?: 'OtaReleaseDocument', id: string, deviceModel: string, firmwareName: string, version: string, sha: string, profile: Types.DeviceProfile, channel: Types.OtaReleaseChannel, notes: string, status: Types.OtaReleaseStatus, createdAt: Types.TDateISO, publishedAt?: Types.TDateISO | null, haltedAt?: Types.TDateISO | null, haltReason: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOtaRolloutsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OtaRolloutDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OtaRolloutDocumentSortInput> | Types.OtaRolloutDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOtaRolloutsQuery = { __typename?: 'Query', otaRollouts?: { __typename?: 'OtaRolloutsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OtaRolloutDocument', id: string, lineId: string, releaseId: string, deviceModel: string, firmwareName: string, version: string, eligibleCountAtStart: number, status: Types.OtaRolloutStatus, currentRing: number, skippedRings: Array<number>, startedAt: Types.TDateISO, startedBy: string, endedAt?: Types.TDateISO | null, haltReason: string, rings: Array<{ __typename?: 'OtaRingPlanDocument', kind: Types.OtaRingKind, deviceIds: Array<string>, cutoffBps: number, maxDevices?: number | null, minApplied: number, successBps: number, haltMinFailures: number, haltBps: number }>, openedRings: Array<{ __typename?: 'OtaOpenedRingDocument', ringIndex: number, deviceCount: number, openedAt: Types.TDateISO }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOtaFirmwareReleasesQueryVariables = Types.Exact<{
  deviceModel?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOtaFirmwareReleasesQuery = { __typename?: 'Query', firmwareReleases: Array<{ __typename?: 'FirmwareRelease', deviceModel: string, firmwareName: string, version: string, sha: string }> };

export const OtaReleaseRowFragmentDoc = new TypedDocumentString(`
    fragment OtaReleaseRow on OtaReleaseDocument {
  id
  deviceModel
  firmwareName
  version
  sha
  profile
  channel
  notes
  status
  createdAt
  publishedAt
  haltedAt
  haltReason
}
    `, {"fragmentName":"OtaReleaseRow"});
export const OtaRolloutRowFragmentDoc = new TypedDocumentString(`
    fragment OtaRolloutRow on OtaRolloutDocument {
  id
  lineId
  releaseId
  deviceModel
  firmwareName
  version
  eligibleCountAtStart
  status
  currentRing
  rings {
    kind
    deviceIds
    cutoffBps
    maxDevices
    minApplied
    successBps
    haltMinFailures
    haltBps
  }
  openedRings {
    ringIndex
    deviceCount
    openedAt
  }
  skippedRings
  startedAt
  startedBy
  endedAt
  haltReason
}
    `, {"fragmentName":"OtaRolloutRow"});
export const OtaReleaseStateFragmentDoc = new TypedDocumentString(`
    fragment OtaReleaseState on OtaReleaseStateData {
  releaseId
  status
}
    `, {"fragmentName":"OtaReleaseState"});
export const OtaRolloutStateFragmentDoc = new TypedDocumentString(`
    fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}
    `, {"fragmentName":"OtaRolloutState"});
export const OtaRolloutOperationFragmentDoc = new TypedDocumentString(`
    fragment OtaRolloutOperation on OtaRolloutOperationData {
  applied
  reason
  rollout {
    ...OtaRolloutState
  }
}
    fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}`, {"fragmentName":"OtaRolloutOperation"});
export const GetOtaReleasesDocument = new TypedDocumentString(`
    query GetOtaReleases($where: OtaReleaseDocumentFilterInput, $order: [OtaReleaseDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  otaReleases(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...OtaReleaseRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OtaReleaseRow on OtaReleaseDocument {
  id
  deviceModel
  firmwareName
  version
  sha
  profile
  channel
  notes
  status
  createdAt
  publishedAt
  haltedAt
  haltReason
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOtaRolloutsDocument = new TypedDocumentString(`
    query GetOtaRollouts($where: OtaRolloutDocumentFilterInput, $order: [OtaRolloutDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  otaRollouts(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...OtaRolloutRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OtaRolloutRow on OtaRolloutDocument {
  id
  lineId
  releaseId
  deviceModel
  firmwareName
  version
  eligibleCountAtStart
  status
  currentRing
  rings {
    kind
    deviceIds
    cutoffBps
    maxDevices
    minApplied
    successBps
    haltMinFailures
    haltBps
  }
  openedRings {
    ringIndex
    deviceCount
    openedAt
  }
  skippedRings
  startedAt
  startedBy
  endedAt
  haltReason
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOtaFirmwareReleasesDocument = new TypedDocumentString(`
    query GetOtaFirmwareReleases($deviceModel: String) {
  firmwareReleases(deviceModel: $deviceModel) {
    deviceModel
    firmwareName
    version
    sha
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOtaReleases: build.query<GetOtaReleasesQuery, GetOtaReleasesQueryVariables | void>({
      query: (variables) => ({ document: GetOtaReleasesDocument, variables })
    }),
    GetOtaRollouts: build.query<GetOtaRolloutsQuery, GetOtaRolloutsQueryVariables | void>({
      query: (variables) => ({ document: GetOtaRolloutsDocument, variables })
    }),
    GetOtaFirmwareReleases: build.query<GetOtaFirmwareReleasesQuery, GetOtaFirmwareReleasesQueryVariables | void>({
      query: (variables) => ({ document: GetOtaFirmwareReleasesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOtaReleasesQuery, useLazyGetOtaReleasesQuery, useGetOtaRolloutsQuery, useLazyGetOtaRolloutsQuery, useGetOtaFirmwareReleasesQuery, useLazyGetOtaFirmwareReleasesQuery } = injectedRtkApi;
